import pluralize from "lib/pluralize";
import BookType from "types/BookType";
import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import Badge from "hardcover-ui/components/Badge";
import BookGroupHeaderWrapper from "components/BookGroup/headers/parts/BookGroupHeaderWrapper";
import { BookGroupSizeType } from "components/BookGroup/types";

export default function SimilarBooksHeader({
  books,
  size,
}: {
  books: BookType[];
  size: BookGroupSizeType;
}) {
  return (
    <BookGroupHeaderWrapper size={size}>
      <div className="flex flex-row space-x-2 mb-1">
        <Text variant="secondary" as="p" size="sm" className="font-semibold">
          Books
        </Text>
        <Badge size="sm" variant="secondary">
          {books.length.toLocaleString()} {pluralize("book", books.length)}
        </Badge>
      </div>

      <Heading level={3} size={size === "lg" ? "md" : "sm"} className="mb-2">
        Readers of This Book Also Enjoyed
      </Heading>

      <Text variant="secondary" as="p">
        If you enjoyed this book, then our algorithm says you may also enjoy
        these.
      </Text>
    </BookGroupHeaderWrapper>
  );
}
